import { Link } from "react-router-dom";
import { useState } from "react";

interface WalletLinkProps {
  address: string;
  truncate?: boolean;
  showCopy?: boolean;
  className?: string;
}

export function WalletLink({
  address,
  truncate = true,
  showCopy = false,
  className = "",
}: WalletLinkProps) {
  const [copied, setCopied] = useState(false);

  const displayAddress = truncate
    ? `${address.slice(0, 4)}...${address.slice(-4)}`
    : address;

  const handleCopy = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    await navigator.clipboard.writeText(address);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      <Link
        to={`/wallet/${address}`}
        className="font-mono text-blue-400 hover:text-blue-300 hover:underline break-all"
        title={address}
      >
        {displayAddress}
      </Link>
      {showCopy && (
        <button
          onClick={handleCopy}
          className="text-gray-400 hover:text-gray-100 p-1 rounded transition-colors"
          title={copied ? "Copied" : "Copy address"}
          aria-label={copied ? "Copied" : "Copy address"}
        >
          {copied ? (
            <svg
              className="w-4 h-4 text-green-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          ) : (
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
              />
            </svg>
          )}
        </button>
      )}
    </span>
  );
}
